import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import { DatePicker } from 'material-ui-pickers';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import { DeleteButton } from 'components/core';
import { selectClientJobs } from 'store/selectors';
import { startEditProject, startRemoveProjectField } from 'store/actions/projects';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  root: {
    width: '430px',
    margin: theme.spacing.unit,
  },
  width: {
    width: '170px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing.unit*2,
  },
  column: {
    display: 'flex',
    flexDirection: 'column'
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
    position: 'relative',
    backgroundColor: '#fff',
    borderRadius: '5px',
  },
});

const JobBasics = (props) => {
  const {
    classes, project, showValidation, validation, clientJobs,
    clients, startEditProject, startRemoveProjectField,
    help,
  } = props;

  return (
    <Card className={classes.root}>
      <CardHeader
        title="Job Basics"
        subheader="Enter in the basic details along with a description of the work. These will be printed on your job sheet."
      />
      <CardContent>
        <Tooltip type={TooltipTypes.job.BASIC_INFO} placement="top">
          <div className={classNames(classes.column, help.isCurrentStep(TooltipTypes.job.BASIC_INFO) && classes.elevate)}>
            <div className={classes.row}>
              <FormControl
                error={ showValidation ? !!validation.validateField("clientId") : false }
                className={classNames(classes.width: classes.marginBottom)}
                style={{marginRight: '5px'}}
              >
                <InputLabel htmlFor="client-simple">Client</InputLabel>
                <Select
                  value={project.clientId === undefined ? "" : project.clientId}
                  onChange={(event) => {
                    startEditProject(project.id, {clientId: event.target.value})
                  }}
                  inputProps={{
                    name: 'clientId',
                    id: 'client-simple',
                  }}
                >
                  {clients &&
                    clients.map((client, i) => {
                      return <MenuItem key={i} value={client.id}>{client.fullName}</MenuItem>
                    })
                  }
                </Select>
                {showValidation && validation.validateField("clientId") &&
                  <FormHelperText>{validation.validateField("clientId")}</FormHelperText>
                }
              </FormControl>
              <TextField
                error={(showValidation && !!validation.validateField(`jobCode`))}
                helperText={(showValidation && validation.validateField(`jobCode`))}
                className={classNames(classes.width, classes.marginBottom)}
                label="Job Code"
                margin="none"
                value={project.jobCode}
                onChange={(event) => startEditProject(project.id, {jobCode: event.target.value})}
              />
            </div>
            <div className={classes.row}>
              <DatePicker
                  className={classNames(classes.width, classes.marginBottom)}
                  style={{marginRight: '5px'}}
                  label="Start Date"
                  format="MMMM Do YYYY"
                  value={project.startDate ? project.startDate : null}
                  leftArrowIcon={<ArrowBackIcon />}
                  rightArrowIcon={<ArrowForwardIcon />}
                  onChange={(date) => startEditProject(project.id, {startDate: date.toDate().getTime()})}
                />
                <DatePicker
                    className={classNames(classes.width, classes.marginBottom)}
                    label="End Date (optional)"
                    format="MMMM Do YYYY"
                    value={project.endDate ? project.endDate : null}
                    leftArrowIcon={<ArrowBackIcon />}
                    rightArrowIcon={<ArrowForwardIcon />}
                    onChange={(date) => startEditProject(project.id, {endDate: date.toDate().getTime()})}
                  />
                <DeleteButton
                  onClick={() => startRemoveProjectField(project.id, "endDate")}
                />
            </div>
          </div>
        </Tooltip>
        <TextField
          className={classes.field}
          margin="dense"
          id="name"
          label="Description/Solution"
          fullWidth
          multiline={true}
          rows={6}
          value={project.jobDescription}
          onChange={(event) => startEditProject(project.id, {jobDescription: event.target.value})}
        />
        {false &&
          <FormControl
            style={{margin: '0px'}}
            className={classNames(classes.formControl, classes.field)}>
            <InputLabel htmlFor="location-simple">Location</InputLabel>
            <Select
              value={"1"}
              onChange={() => console.log("location")}
              inputProps={{
                name: 'locationId',
                id: 'location-simple',
              }}
            >
              <MenuItem value={1}>At Client</MenuItem>
              <MenuItem value={2}>At Home</MenuItem>
              <MenuItem value={3}>Other</MenuItem>
            </Select>
          </FormControl>
        }
      </CardContent>
    </Card>
  );
};

const mapStateToProps = (state) => {
  const { id: projectId, showValidation } = state.adminState.project;
  const validation = state.validation.projects.find(item => item.id === projectId);
  const clients = state.clientsState;

  return {
    clientJobs: selectClientJobs(state),
    clients,
    showValidation,
    validation,
    help: state.help,
  }
};


const mapDispatchToProps = {
  startEditProject,
  startRemoveProjectField
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(JobBasics);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/JobBasics.jsx